import type FetchService from '../FetchService';
import type { Study } from './types';

class StudyApi {
  protected baseUrl = '/study';

  constructor(protected fetchService: FetchService) {}

  getStudy(studyId: string) {
    return this.fetchService.get<Study>(`${this.baseUrl}/${studyId}`);
  }
}

export default StudyApi;
